import { Pen } from "../../../../Definitions";
import { DirectionOptions, PatternOptions, StartCornerOptions } from "../../../../Definitions/newSectionModalInterfaces";

export function generateNumberedGrid( rows: number, columns: number, startCorner: StartCornerOptions, direction: DirectionOptions, pattern: PatternOptions, startingNumber: number ): Pen[] {
  const pens: Pen[] = [];
  const rowIndices = Array.from({ length: rows }, (_, i) => i);
  const colIndices = Array.from({ length: columns }, (_, i) => i);
  
  const rowOrder = startCorner === StartCornerOptions.bottomLeft || startCorner === StartCornerOptions.bottomRight
  ? rowIndices.reverse()
  : rowIndices;

  const colOrder = startCorner === StartCornerOptions.topRight || startCorner === StartCornerOptions.bottomRight
    ? colIndices.reverse()
    : colIndices;
    
  let number = startingNumber;
  let coords: [number, number][] = [];

  if (direction === DirectionOptions.horizontal) {
    if (pattern === PatternOptions.z) {
      for (const r of rowOrder) {
        for (const c of colOrder) { coords.push([r, c]) }
      }
    } else if (pattern === PatternOptions.u) {
      let forward = true;
      for (const r of rowOrder) {
        if (forward) {
          for (const c of colOrder) { coords.push([r, c]) }
        } else {
          for (const c of colOrder.slice().reverse()) { coords.push([r, c]) }
        }
        forward = !forward;
      }
    }
  } else {
    if (pattern === PatternOptions.z) {
      for (const c of colOrder) {
        for (const r of rowOrder) { coords.push([r, c]) }
      }
    } else if (pattern === PatternOptions.u) {
      let forward = true;
      for (const c of colOrder) {
        if (forward) {
          for (const r of rowOrder) { coords.push([r, c]) }
        } else {
          for (const r of rowOrder.slice().reverse()) { coords.push([r, c]) }
        }
        forward = !forward;
      }
    }
  }
  for (const [r, c] of coords) {
    const penId = `${r * columns + c}`;
    const visual = `${r + 1}/${c + 1}/${r + 2}/${c + 2}`;
    pens.push({ penId, name: String(number++), visual, id: "", io: null });
  }

  return pens;
}